import React from 'react';
import { ModalContainer } from '../../../../../shared/modal-container/ModalContainer';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { updateUser } from '../redux/update-user/actions';
import { EditUserModalContent } from './EditUserModalContent';

const handleEditUser = (props, userDetails) => {
    const { user, editUser } = props;
    const { firstName, lastName, active } = userDetails;

    user &&
        _.isFunction(editUser) &&
        editUser(user.id, {
            firstName: firstName || user.firstName,
            lastName: lastName || user.lastName,
            active: active || user.active
        });
    _.isFunction(props.forwardedRef.current.closeModal) &&
        props.forwardedRef.current.closeModal();
};

const EditUserModal = props => (
    <ModalContainer
        content={
            <EditUserModalContent
                user={props.user}
                editTeam={userDetails => handleEditUser(props, userDetails)}
            />
        }
        title={'Edit User'}
        ref={props.forwardedRef}
    />
);
const mapDispatchToProps = dispatch => ({
    editUser: (userId, details) => dispatch(updateUser({ userId, details }))
});

const ConnectedEditUserModal = connect(null, mapDispatchToProps)(EditUserModal);

export default React.forwardRef((props, ref) => (
    <ConnectedEditUserModal {...props} forwardedRef={ref} />
));
